module.exports = __webpack_public_path__ + "static/lahli_spinach_rustica_illustration_BG_900x702-b10ba459d085fb6b7b62202e4a210640.jpg";